// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bundle__c15 + .bundle__c15 {
  margin-top: calc(var(--ring-uint) * 2);
}
`, "",{"version":3,"sources":["webpack://./src/pages/profiles/profile-details/profile-ide-provisioner/plugin-rules/plugin-rules.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;AACxC","sourcesContent":[".bundle + .bundle {\n  margin-top: calc(var(--ring-uint) * 2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bundle": `bundle__c15`
};
export default ___CSS_LOADER_EXPORT___;
